import { createApp } from 'vue'
import Karekok from './Karekok.vue'
import './assets/global.css'

createApp(Karekok).mount('#karekok')
